import styled from 'styled-components';
import { fadeinout } from 'styles/animations';

export const Window = styled.div`
  border-radius: 5px;
  background-color: ${({ theme }) => theme.windowBg};
  box-shadow: 5px 5px 3px ${({ theme }) => theme.shadowColor};
  // Dunno why need 95% for it to fit
  height: 95%;
  margin: 10px;
  padding: 15px;
  box-sizing: border-box;
  overflow: auto;

  animation: ${fadeinout} 0.3s linear;
  -webkit-animation: ${fadeinout} 0.3s linear;
  -moz-animation: ${fadeinout} 0.3s linear;
  -o-animation: ${fadeinout} 0.3s linear;
  -ms-animation: ${fadeinout} 0.3s linear;

  pointer-events: auto;

  @media only screen and (max-height: 500px) {
    height: 90%;
  }
`;

